import { useEffect } from 'react';

let lockCount = 0;
const savedOverflows: Map<HTMLElement, string> = new Map();

export function useScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;

    const elements = Array.from(
      document.querySelectorAll<HTMLElement>('[data-scroll-container]')
    );

    if (lockCount === 0) {
      elements.forEach(el => {
        savedOverflows.set(el, el.style.overflow);
        el.style.overflow = 'hidden';
      });
    }
    lockCount++;

    return () => {
      lockCount--;
      if (lockCount <= 0) {
        lockCount = 0;
        savedOverflows.forEach((saved, el) => { el.style.overflow = saved; });
        savedOverflows.clear();
      }
    };
  }, [isLocked]);
}
